<div id="loadingScreen">
  <div class="loading-wrap">
    <img src="{{assetsRoute}}/picture/Loading.gif" alt="">
    <!--<div class="loading-process">-->
      <!--<div class="process-gif"></div>-->
    <!--</div>-->
    <div class="error-text" >玩命加载中...</div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/loading/loading.component.html